"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBasketOffer = addBasketOffer;
var AddBasketOfferFailed = _interopRequireWildcard(require("@ori-events/add-basket-offer-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _convertToCamelCase = require("./convertToCamelCase");
var _getHttpRequestSettings = require("./getHttpRequestSettings");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function addBasketOffer(url, params) {
  const response = await fetch(url, (0, _getHttpRequestSettings.getHttpRequestSettings)(params, _checkoutUtils.HttpMethod.Post));
  const data = (0, _convertToCamelCase.convertToCamelCase)(await response.json());
  if (AddBasketOfferFailed.isAddBasketOfferErrorResponse(data)) {
    const event = new CustomEvent(AddBasketOfferFailed.Name, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  return data;
}
